import { NgModule } from '@angular/core';
import { Routes,
     RouterModule } from '@angular/router';

import { LoginComponent } from './login.component'; 
import { ForgotpasswordComponent } from './forgotpassword.component'; 

const routes: Routes = [
  {
    path: '', 
    data: {
      title: 'Login'
    },
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: {
          title: 'Login'
        }
      },
      {
        path: 'forgotpassword',
        component: ForgotpasswordComponent,
        data: {
          title: 'Forgotten Password'
        }
      } 
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/auth/auth-routing.module.ts